import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, CalendarDays, HelpCircle, PieChart, Vote } from "lucide-react";
import Hero from "../components/Hero";
import { Card, SectionHeading } from "../components/ui";
import { usePortal } from "../lib/portal";

// Home = hero (with clickable flower nodes) + connective links to the
// dedicated pages. All detailed content lives on its own page.

const LINKS = [
  {
    to: "/overview",
    icon: BookOpen,
    title: "Event overview",
    body: "Venue, lunch timing, cohort counts, announcements and deadlines.",
  },
  {
    to: "/menu",
    icon: CalendarDays,
    title: "The menu",
    body: "All 14 sections and 21 dishes, official artwork, per-plate pricing.",
  },
  {
    to: "/voting",
    icon: Vote,
    title: "Voting",
    body: "One combined ballot form for every open poll — date, menu, transport.",
  },
  {
    to: "/budget",
    icon: PieChart,
    title: "Budget",
    body: "Cost breakdowns, junior/senior costs, scenarios and surplus.",
  },
  {
    to: "/faq",
    icon: HelpCircle,
    title: "FAQs",
    body: "How voting works, who can vote, and how the money is handled.",
  },
];

export default function HomePage() {
  const { data } = usePortal();
  return (
    <>
      <Hero event={data!.event} decisionStatus={data!.decisionStatus} />
      <section className="mx-auto max-w-shell px-5 pb-24 pt-16 md:px-10">
        <SectionHeading
          eyebrow="[ WHERE TO GO ]"
          title="Everything, one link at a time"
          description="Each part of the portal lives on its own page. Pick a link below — or click the glowing nodes in the hero art above."
        />
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {LINKS.map(({ to, icon: Icon, title, body }) => (
            <Link key={to} to={to} className="group">
              <Card className="h-full p-6 transition-colors group-hover:border-white/30">
                <Icon className="h-5 w-5 text-wandor-prompt" aria-hidden="true" />
                <h3 className="mt-3 flex items-center gap-2 text-lg font-medium text-white">
                  {title}
                  <ArrowRight
                    className="h-4 w-4 text-white/40 transition-transform group-hover:translate-x-1"
                    aria-hidden="true"
                  />
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-white/55">{body}</p>
              </Card>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
